import { useLocSettings } from "../../hooks/SettingsHooks";
import classNames from "classnames";

const ContactInfo = ({ className }) => {
  const { footer } = useLocSettings();
  return (
    <div className={classNames(className)}>
      <h4>{footer.company_name}</h4>
      {footer.postal_address && (
        <p className={"pre-wrap"} style={{ marginBottom: "0.4rem" }}>
          {footer.postal_address.replace(/[,][ ]/g, "\n")}
        </p>
      )}
      {footer.contact_email && (
        <p style={{ marginBottom: "0.4rem" }}>
          <a href={"mailto:" + footer.contact_email}>{footer.contact_email}</a>
        </p>
      )}
      {footer.contact_phone && (
        <p style={{ marginBottom: "0.4rem" }}>
          <a href={"tel:" + footer.contact_phone.replace(/[- ]+/g, "")}>
            {footer.contact_phone}
          </a>
        </p>
      )}
    </div>
  );
};

export default ContactInfo;
